import React from "react";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import { scheduleText } from "../features/rule.utils";

// Columns of the Rule list. `start` is the row number offset of the current page.
export const getRuleColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "name",
    label: "Rule",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.name}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.code}</span>
      </div>
    ),
  },
  {
    key: "trigger_fid",
    label: "Trigger",
    sortable: true,
    render: (row) =>
      row.trigger ? (
        <div className="flex min-w-0 flex-col">
          <span className="truncate text-xs text-text_secondary">{row.trigger.name}</span>
          <span className="text-[11px] text-text_muted">
            {TRIGGER_TYPE_LABEL[row.trigger.trigger_type] ?? row.trigger.trigger_type}
            {row.module ? ` · ${row.module.label}` : ""}
          </span>
        </div>
      ) : (
        <span className="text-xs text-text_muted">—</span>
      ),
  },
  {
    key: "schedule",
    label: "Schedule",
    sortable: false,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate text-xs text-text_secondary">{scheduleText(row.schedule)}</span>
        <span className="text-[11px] text-text_muted">{row.timezone || "Activator's timezone"}</span>
      </div>
    ),
  },
  { key: "status", label: "Lifecycle", sortable: true, render: (row) => <LifecycleBadge status={row.status} version={row.published_version_no || undefined} /> },
  {
    key: "next_run_at",
    label: "Next run",
    sortable: true,
    render: (row) => (row.next_run_at && row.status === "ACTIVE" ? <span className="text-xs text-text_secondary"><LocalDateTime utcTime={row.next_run_at} /></span> : <span className="text-xs text-text_muted">—</span>),
  },
  {
    key: "step_count",
    label: "Ladder",
    sortable: false,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        <Chip>{row.step_count ?? 0} steps</Chip>
        <Chip tone={row.open_case_count ? "brand" : "default"}>{row.open_case_count ?? 0} open cases</Chip>
      </div>
    ),
  },
  { key: "is_activated", label: "Status", sortable: true, render: (row) => <ActiveBadge active={row.is_activated} /> },
];
